export const allowedDomains = [
  "",
  "undefined.bookshelf",
  "vitalsource.com",
  "vitalsource.co.uk",
  "vitalbook.com",
  "cengage.com",
  "phoenix.edu",
  "minhabiblioteca.com.br",
  "gilmoreglobal.com",
  "digitalcontenthelp.com",
  "editoraatlas.com.br",
  "yuzu.com",
  "bncollege.com",
  "bookrenter.com",
  "bookrenterstore.com",
  "itdepartment.nl",
  "studystore.nl",
  "brownmackie.edu",
  "brytewave.com",
  "ccl.org",
  "vsapplications.com",
  "clever.com",
  "lww.com",
  "devryu.net",
  "edx.org",
  "coursewareobjects.com",
  "elsevier.com",
  "gsionline.com.br",
  "senac.br",
  "heimkaup.is",
  "digitalcontenthelp.com",
  "gwinnett.k12.ga.us",
  "learningfield.com.au",
  "mandrelworks.com",
  "bookrenter.com",
  "bookmarkonline.co.za",
  "bookshelf.nl",
  "sideriscourseware.com",
  "studieboekencentrale.nl",
  "textbooks.com",
  "vanschaik.com",
  "xlibrio.zendesk.com",
  "xlibrio.com",
  "vsapplications.com",
  "vstbridge.com",
  "cengagebrain.com",
  "onedrive.live.com",
  "google.com",
  "apple.com",
  "itunes.com",
  "chegg.com",
  "www.chegg.com",
  "miheexplorers.com",
  "follett.com",
  "clinicalkey.com",
  "td.org",
  "redi.mcgrawhill.com",
  "mcgrawhill.com",
  "talentsmart.com",
  "suporteminhabiblioteca.zendesk.com",
  "support.evantage.ca",
  "us.sagepub.com",
  "sagepub.com",
  "genealogical.com",
  "mhe.my.site.com",
  "emond.ca",
];

export const allowedProtocols = [
  "http:",
  "https:",
  "vbk:",
  "bned:",
  "itms-apps:",
  "cheggereader:",
  "ckmeded:",
  "unibb:",
  "manole:",
  "lens:",
  "elsevier:",
  "macmillan:",
  "wiley:",
];

export const blockedProtocols = [
  "data:",
  "data:text",
  "data:text/html",
  "xss:",
  "mysql:",
  "javascript:",
];
